export const statusList = {
  OK: "",
  INVALID_SESSION: "errors.api_invalid_session",
  MISSING_PARAMETER: "errors.api_missing_parameter",
  INVALID_PARAMETER: "errors.api_invalid_parameter",
  ACCESS_DENIED: "errors.api_access_denied",
  INTERNAL_ERROR: "errors.api_internal_error",
  EMAIL_ALREADY_HAS_VALID_INVITATION: "errors.userInvitation.already_invited",
  CANNOT_UPDATE_INVITATION: "errors.userInvitation.cannot_update_invitation",
  SUBCONTRACT_DOES_NOT_EXIST: "errors.userInvitation.subcontract_does_not_exist",
  CANNOT_SHARE_DEVICE: "errors.userInvitation.cannot_share_device",
  RESTRICTED_ROLE_FOR_INVITEE: "errors.userInvitation.restricted_role",
  INVALID_EMAIL_ADDRESS: "errors.invalid_email_address",
  DEVICE_ALREADY_ADDED: "errors.device_already_added",
  MULTI_TENANCY_NOT_ENABLED: "errors.multi_tenancy_not_enabled",
  CANNOT_ACCESS_DEVICE: "errors.cannot_access_device",
};

export type Status = keyof typeof statusList

export interface Response<T> {
  status: Status;
  result?: T;
  error?: Record<string, unknown>;
}

export type Result<T> =
  | {
    success: true;
    data: T;
    error: null;
  }
  | {
    success: false;
    data: null;
    error: {
      status: Status;
      messageKey: string;
      details?: Record<string, unknown>;
    };
  };

export function mapStatusToMessage(status: Status) {
  if (statusList[status]) return statusList[status];
  return "errors.custom_backend_error";
}

export async function apiV3Call<Req, Res>(
  url: string,
  body: Req
): Promise<Result<Res>> {
  try {
    const response = await fetch(url, {
      method: "POST",
      credentials: "include", // important for session cookie
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(body),
    });

    const ret = (await response.json()) as Response<Res>;

    if (ret.status !== "OK") {
      return {
        success: false,
        data: null,
        error: {
          status: ret.status,
          messageKey: mapStatusToMessage(ret.status),
          details: ret.error ?? {},
        },
      };
    }

    return {
      success: true,
      data: ret.result as Res,
      error: null,
    };
  } catch (err: unknown) {
    return {
      success: false,
      data: null,
      error: {
        status: "INTERNAL_ERROR",
        messageKey: mapStatusToMessage("INTERNAL_ERROR"),
        details: { fetch: err },
      },
    };
  }
}
